
    // IMPORTS
    import { defineComponent, PropType } from 'vue'
    import { buildLocalization } from '@/util'

    import { Button } from '@progress/kendo-vue-buttons'
    import { DialogActionsBar } from '@progress/kendo-vue-dialogs'
    import AppDialog from '@/components/common/app-dialog.vue'
    import MyIcon from '@/components/common/my-icon.vue'

    export default defineComponent({
        name: 'RequestAccountResultDialog',

        components: {
            AppDialog,
            'k-button': Button,
            DialogActionsBar,
            MyIcon
        },

        props: {
            isSuccess: { type: Boolean as PropType<boolean>, required: true }
        },

        emits: ['close'],

        setup() {
            const { localize } = buildLocalization()
            return { localize }
        }
    })
